import React from "react";
import styled from "styled-components";
import SVG from "react-inlinesvg";
import FeatherIcon from "feather-icons-react";
import { toAbsoluteUrl } from "_metronic/_helpers";
import { colors } from "app/popleads/components/ui-kit/colors";
import { decideFileType } from "app/popleads/modules/activities/utils";

/* A slim pill sized to its content rather than a square card: several of these sit on one line
   above the composer, and a name is the only thing that tells two attached PDFs apart, so it gets
   the width — a fixed square spent most of its area on a preview or an icon and left the name two
   cramped lines to wrap into. */
const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 160px;
    height: 28px;
    padding: 0 8px;
    border-radius: 8px;
    border: 1px solid ${colors.neutral[100]};
    background-color: ${colors.white};
    box-sizing: border-box;
`;

const Icon = styled(SVG)`
    flex-shrink: 0;
    width: 14px;
    height: 14px;
`;

const Name = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 500;
    color: ${colors.neutral[800]};
`;

const RemoveButton = styled.button`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: ${colors.neutral[500]};
    cursor: pointer;

    &:hover {
        background-color: ${colors.neutral[100]};
        color: ${colors.neutral[800]};
    }

    svg {
        width: 11px;
        height: 11px;
    }
`;

/**
 * One attached file, staged or already sent — name and type only, no preview. An image used to get
 * its own thumbnail here; removed on request, so every file now reads the same way regardless of
 * type, and the name — the one thing that tells two attachments apart — gets the width instead of
 * sharing it with a picture.
 *
 * `onRemove` is what tells staged from sent apart: present while the file can still be taken back,
 * absent once it is part of what was actually asked and archived that way.
 */
const AttachmentChip = ({ name, onRemove }) => (
    <Chip>
        <Icon src={toAbsoluteUrl(decideFileType(name))} />
        <Name title={name}>{name}</Name>
        {onRemove && (
            <RemoveButton type="button" onClick={onRemove} aria-label={`Remove ${name}`}>
                <FeatherIcon icon="x" size={11} />
            </RemoveButton>
        )}
    </Chip>
);

export default AttachmentChip;
